import { useRuntimeConfig } from '#imports'

/**
 * Origem Flow: detalhes de "hydration mismatch" no console do navegador.
 *
 * Por padrão o Vue de produção só avisa que houve divergência entre o HTML do
 * servidor e o do navegador, sem dizer onde. Com
 * BASEROW_HYDRATION_MISMATCH_DETAILS=true ele passa a apontar o nó, o atributo
 * e os dois valores — o suficiente para achar a origem sem reconstruir a
 * imagem com outra configuração de build.
 *
 * O valor precisa estar de pé antes da hidratação, por isso o plugin roda cedo
 * e apenas grava a variável global que a flag do Vue consulta.
 */
export default defineNuxtPlugin({
  name: 'origem-flow-hydration-mismatch-details',
  enforce: 'pre',
  setup() {
    const value = useRuntimeConfig().public.hydrationMismatchDetails
    globalThis.__origemFlowHydrationDetails__ = ['true', '1', 'on'].includes(
      String(value).toLowerCase()
    )
  },
})
